module.exports = __webpack_public_path__ + "img/XUC.f40ea9c4.svg";